import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { GEMINI_MODELS, getStoredGeminiModel, setStoredGeminiModel } from '../utils/geminiModel';
import DbSwitcher from './DbSwitcher';

const DashboardHeader = ({ title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [geminiModel, setGeminiModel] = useState(getStoredGeminiModel);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleModelChange = (e) => {
    setGeminiModel(setStoredGeminiModel(e.target.value));
  };

  return (
    <header className="dashboard-header">
      <h1>{title}</h1>
      <div className="user-info">
        <DbSwitcher />
        <select
          id="global-gemini-model"
          className="db-switcher"
          value={geminiModel}
          onChange={handleModelChange}
          title="Active Gemini model"
        >
          {GEMINI_MODELS.map((model) => (
            <option key={model} value={model}>
              {model}
            </option>
          ))}
        </select>
        <span>Welcome, {user?.username || user?.email}</span>
        <button type="button" onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
